import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useHomePage = (galleryLength) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [activeGallery, setActiveGallery] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Track window scroll positions for nav transitions
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Auto-advance hero background slideshow
  useEffect(() => {
    if (!galleryLength) return;
    const t = setInterval(() => setActiveGallery(p => (p + 1) % galleryLength), 3500);
    return () => clearInterval(t);
  }, [galleryLength]);

  const handleQuickAccess = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.label === 'Support') {
      setIsModalOpen(true);
    } else {
      navigate(item.path);
    }
  };

  return {
    navigate,
    scrolled,
    activeGallery,
    setActiveGallery,
    isModalOpen,
    setIsModalOpen,
    handleQuickAccess
  };
};




